var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"status-indicator-line d-flex justify-center align-center"},[_vm._v(" pending ")])
}
var staticRenderFns = []

export { render, staticRenderFns }